import Helpers from "@/services/helpers";

import { SET_QUEUE_INDEX, SET_CURRENT_TRACK_ID } from "@/store/mutation-types";

export default class Queue {
  constructor(store) {
    this.store = store;

    Helpers.mapStore(this, {
      currentTrackId: {
        get: "queue/currentTrackId",
        set: `queue/${SET_CURRENT_TRACK_ID}`
      },
      index: {
        get: "queue/currentIndex",
        set: `queue/${SET_QUEUE_INDEX}`
      }
    });
  }
  async add(tracksIds = []) {
    await this.store.dispatch("tracks/fetch", {
      params: {
        ids: tracksIds.filter(id => !this.tracksStore[id])
      }
    });

    this.store.dispatch("queue/add", tracksIds);
    this.store.dispatch("queue/setPosition");

    if (!this.currentTrackId) {
      this.currentTrackId = this.tracklistIds[this.index];
    }
  }
  async remove(tracksId) {
    this.store.dispatch("queue/remove", tracksId);
    this.store.dispatch("queue/setPosition");
  }
  clear() {
    this.store.dispatch("queue/clear");
    this.currentTrackId = null;
    this.index = 0;
  }
  setIndex(index) {
    this.index = index;
    this.currentTrackId = this.tracklistIds[this.index];
    this.store.dispatch("queue/setPosition");
  }
  get tracklistIds() {
    return this.store.getters["queue/tracklist"];
  }
  get tracksStore() {
    return this.store.getters["tracks/tracks"];
  }
}
